import React from 'react';
import Feature from '../services/Feature';

export type FeatureFlagsType = {
  useCases: boolean
}

export const FeatureFlags = React.createContext<FeatureFlagsType | null>(null);

export const FeatureFlagsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isLoading, setIsLoading] = React.useState(true);
  const [features, setFeatures] = React.useState<FeatureFlagsType>({
    useCases: false
  });

    React.useEffect(() => {
      (async () => {
        try {
          const data = await Feature.fetchFeatures();
          if (data.content.value) {
            setFeatures(data.content.value);
          }
        } catch (err) {
          console.log(err);
        } finally {
          setIsLoading(false);
        }
      })();
    }, []);

    return (
      <FeatureFlags.Provider value={ features }>
        {isLoading ? "Loading..." : children}
      </FeatureFlags.Provider>
    );
};
